import React, { Fragment, useEffect } from "react";
import { Col, Rate, Slider } from "antd";
import { FrownOutlined, SmileOutlined } from "@ant-design/icons";
import { useSurveyInputStore } from "../../../../surveyStore";
import useEvaluateParameters from "../../question-preview/hooks/useEvaluateParameters";
import useEvaluateAppearance from "../../question-preview/hooks/useEvaluateAppearance";
import PreviewQuestionLabel from "../../../common/PreviewQuestionLabel/PreviewQuestionLabel";
import PreviewQuestionConstraints from "../../../common/PreviewQuestionConstraints/PreviewQuestionConstraints";

import style from "./RangeQuestion.module.scss";

function generateMarksObject(start, end) {
   const marks = {};

   for (let i = start; i <= end; i++) {
      marks[i] = i.toString();
   }

   return marks;
}

export const RangeQuestion = React.memo(
   ({ props, surveyId, userId, submissionId, label, hint }) => {
      const { id, questionType, isRequired, range, answers } = props;

      const inputState = useSurveyInputStore((state) => state.inputs?.[id]);
      const setInputs = useSurveyInputStore((state) => state.setInputs);
      const hasSubmissionId = Boolean(submissionId);
      const submissionAnswer = hasSubmissionId
         ? answers?.find((answer) =>
              props.repeatInstanceIndex
                 ? answer?.answerDetail.repeatGroup === props.repeatInstanceIndex
                 : answer
           )?.answerDetail?.number
         : null;

      const parameters = useEvaluateParameters({
         parameters: props.parameters
      });

      const appearance = useEvaluateAppearance({
         appearance: props.appearance
      });

      const onChange = (e) => {
         if (hasSubmissionId) return;

         if (!e) {
            setInputs({
               target: {
                  name: id,
                  value: ""
               }
            });
         } else {
            setInputs({
               target: {
                  name: id,
                  value: {
                     surveyId: surveyId,
                     userId: userId,
                     questionId: id,
                     questionType: questionType,
                     name: props.name,
                     skipLogicAnswer: e,
                     answerDetail: {
                        number: e
                     }
                  }
               }
            });
         }
      };

      useEffect(() => {
         if (parameters?.step) {
            onChange(parameters?.step);
         }
         // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [parameters?.step]);

      return (
         <Col lg={24} md={24} sm={24} xs={24}>
            <PreviewQuestionLabel label={label} isRequired={isRequired} hint={hint} />
            <PreviewQuestionConstraints constraintMessages={props.constraintMessages} />

            <div className={style.wrapper}>
               {appearance.includes("rating") ? (
                  <Rate
                     count={parameters?.end || 5}
                     onChange={onChange}
                     value={inputState?.answerDetail?.number ?? submissionAnswer ?? 0}
                     defaultValue={parameters?.step || 0}
                  />
               ) : (
                  <Fragment>
                     <div className={`${style.absolute} ${style.left}`}>
                        <p className={style.text}> {range?.firstLabel}</p>
                        <FrownOutlined className="icon" />
                     </div>

                     <Slider
                        min={parameters?.start || 1}
                        max={parameters?.end || 5}
                        marks={generateMarksObject(parameters?.start || 1, parameters?.end || 5)}
                        onChange={onChange}
                        value={inputState ? inputState?.answerDetail?.number : submissionAnswer}
                        defaultValue={parameters?.step || 0}
                     />
                     <div className={`${style.absolute} ${style.right}`}>
                        <p className={style.text}> {range?.secondLabel} </p>
                        <SmileOutlined className="icon" />
                     </div>
                  </Fragment>
               )}
            </div>
         </Col>
      );
   }
);
